import { getAgentSearchParams } from 'storage/agentSearch';

export function isAgentLogin(): boolean {
  const searchParams = getAgentSearchParams();
  if (!searchParams) {
    return false;
  }

  const params = new URLSearchParams(searchParams);
  return !!params.get('policyDetailsId') || (!!params.get('emailAddress') && !!params.get('postcode'));
}
